import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { apiFetch } from "../api/client.js";

/**
 * Resolves user ids to names for the lists, from the same ["users"] query the
 * user pickers use, so the two share one cached request. The lists used to
 * print "User #1" in every owner column, because nothing ever made this
 * lookup. /api/users lists active accounts only; an owner whose account was
 * deactivated still shows as "User #id".
 */
export function useUserName(): (id: number | null | undefined) => string | null {
    const { t } = useTranslation();
    const { data } = useQuery({
        queryKey: ["users"],
        queryFn: () => apiFetch<{ items: Array<{ id: number; name: string }> }>("/api/users"),
        staleTime: 60_000,
    });
    const names = new Map((data?.items ?? []).map((u) => [u.id, u.name]));
    return (id) => (id == null ? null : names.get(id) ?? t("common.userFallback", { id }));
}
